export const interviewResult = [
  { value: 1, label: '合格' },
  { value: 2, label: '不合格' },
  { value: 3, label: '有条件合格', label_ja: '条件付き合格' },
];

export const resultUploaded = [
  { value: 1, label: '未上传', label_ja: '未アップロード' },
  { value: 2, label: '已上传', label_ja: 'アップロード済' },
];


export const schedule = [
  { value: 1, label: '未排期', label_ja: '未手配' },
  { value: 2, label: '已排期', label_ja: '手配済' },
];

export const interviewWay = [
  { value: 1, label: '系统视频面试', label_ja: 'システムビデオインタビュー' },
  { value: 2, label: '系统语音面试', label_ja: 'システム電話面接' },
  { value: 3, label: '材料审核', label_ja: '材料レビュー' },
  { value: 4, label: '电话面试', label_ja: '電話で面接する' },
  { value: 5, label: 'QQ视频面试', label_ja: 'QQビデオインタビュー' },
  { value: 6, label: 'skype视频面试', label_ja: 'skypeビデオインタビュー' },
  { value: 7, label: '微信视频面试', label_ja: '微信ビデオインタビュー' },
  { value: 8, label: '文字面试', label_ja: '文字面接' },
];

// 面试进度
export const interviewProgress = [
  { value: 1, label: '等待面试', label_ja: '面接待ち' },
  { value: 2, label: '等待结果', label_ja: '結果待ち' },
  { value: 3, label: '面试完成', label_ja: '面试完成' },
  { value: 4, label: '面试取消', label_ja: '面试取消' },
];

// 发送校方
export const sendToSchool = [
  { value: 1, label: '未发送', label_ja: '未送信' },
  { value: 2, label: '已发送', label_ja: '送信済' },
];

// 面试状态
export const interviewStatus = [
  { value: 1, label: '犹豫中', label_ja: 'ちゅうちょ中' },
  { value: 2, label: '材料准备中', label_ja: '材料準備中' },
  { value: 3, label: '失联', label_ja: 'れんを失う' },
];
